"use client";
import React, { useState } from "react";
import Link from "next/link";
// console.log(MyData, 'sssss');
import style from "@/app/style/state.module.css";

function allstate({ filteredCities }) {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div>
      <div className=" mb-10">
        <div className="mx-auto max-w-7xl ">
          {/* Content goes here */}
          <div className="mx-auto px-7  mt-10 sm:max-w-7xl  md:max-w-6xl    lg:max-w-7xl xl:text-center">
            <h1 className=" text-3xl  font-bold secondary">
              Choose Your City & Travel with
              <span style={{ color: "#D5AF34" }}>
                {" "}
                <a id="highlight" href="/"></a>{" "}
              </span>
            </h1>

            <p className="updatedparapremu mx-auto max-w-4xl pt-3 mb-12 leading-7">
              Explore the local cultures, customs and culinary delights of major
              cities in the United States with{" "}
              <a id="highlight" href="/">
                Prestige Ride
              </a>
              . Search for your preferred city name and let us know where you
              need to be dropped off.{" "}
              <a id="highlight" href="/booking">
                Book your luxury cars
              </a>{" "}
              for corporate meetings and other special events to make the most
              out of your time.
            </p>
          </div>
          {/* ============================================================================================== */}

          {/* <div className="mx-auto max-w-7xl">
            <div className="grid px-7 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 ">
              {filteredCities.map((server, index) => {
                return (
                  // <>
                  <Link href={server.link} onClick={scrollTop} key={index}>
                    <div
                      id={style.maincitysize}
                      className={style[server.image]}
                    >
                      <div className="mt-1 text-white">
                        <div className="px-4  ">
                          <h2 className=" flex justify-start updatedheading text-white ">
                            {server.title}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </Link>
                  // </>
                );
              })}
            </div>
          </div> */}

          <div className="mx-auto max-w-7xl">
            <div className="grid px-7 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 ">
              {filteredCities
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((server, index) => {
                  return (
                    <Link href={server.link} onClick={scrollTop} key={index}>
                      <div
                        id={style.maincitysize}
                        className={style[server.image]}
                      >
                        <div className="mt-1 text-white">
                          <div className="px-4">
                            <h2 className="flex justify-start updatedheading text-white">
                              {server.title}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default allstate;
